import apiFetch from '../apiFetch'

export default function (token, filter) {
  return apiFetch({ endPoint: 'Report/UsageList/Download', method: 'POST', body: filter, token: token, parseBlobAndAssign: true })
}
